@if (prescriptionsList.length == 0) {
  <div class="row text-center h-100">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center my-auto">
      <div class="card card-block d-flex" style="height: 120px">
        <div class="card-body align-items-center d-flex justify-content-center font-xl">
          No Prescriptions Found
        </div>
      </div>
    </div>
  </div>
}


<!-- Pagination New Flow -->
@if (prescriptionsList.length > 0) {
  <div>
    <div class="row m-0 p-0 bg-white shadow-sm _wf-historytabmaincontainer">
      @if (config.type == 'viewAll') {
        <div class="cursor-pointer m-0 p-0 " id="scrollTestLab" scroll-directive>
          <!-- <button type="button" [attr.disabled]="_currentPage==0 ? '' : null "
          class="pull-left btn btn-outline-primary btn-sm " (click)="goPrev() "><i class="fa fa-arrow-left "
        aria-hidden="true "></i></button>
        <button type="button" class="pull-right btn btn-outline-primary btn-sm "
          [attr.disabled]="getClassToEnableDisableIcon() " (click)="goNext() "><i class="fa fa-arrow-right "
        aria-hidden="true "></i></button>
        <h3>History ({{allPresCount?allPresCount:0}})</h3> -->
        <div class="_wf-historyheading-epricription">
          <div class="w-100 mb-1">History ({{allPresCount?allPresCount:0}})</div>
          <button class="_wf-buttonfornextprev _wf-buttonfornextprev2 " [attr.disabled]="_currentPage==0 ? '' : null "(click)="goPrev() "><i class="fa fa-angle-left"></i>{{'field.label.Previous' | translate | async }}</button>
          <button class="_wf-buttonfornextprev" [attr.disabled]="getClassToEnableDisableIcon() " (click)="goNext() ">Next<i class="fa fa-angle-right"></i></button>
        </div>
        @for (perAppt of prescriptionsList; track perAppt; let i = $index) {
          <div class="_wf-historytab doc-view-list" id="labtestList "
            [ngClass]="{ 'doc-active-tab': i==0?true:false} " (click)="onClickSideList(perAppt,$event,i) ">
            <div class="_wf-historytabheading">
              <div class="_wf-cf-heading">By {{perAppt.practitioner_name}}</div>
              <!-- <div class="_wf-threedot"><i class="fa fa-ellipsis-v"></i></div> -->
            </div>
            <div class="_wf-textinhistorytab">
              <div class="_wf-historytableft">
                <div class="wf0historycategory">Speciality</div>
                <div class="_wf-historybolddata">{{perAppt.speciality_name }}</div>
              </div>
              <div class="_wf-historytableft">
                <div class="wf0historycategory">Time</div>
                <div class="_wf-historybolddata">{{perAppt.g_modify_time | timeFormat}}</div>
              </div>
              <div class="_wf-historytableft">
                <div class="wf0historycategory">Date</div>
                <div class="_wf-historybolddata">{{perAppt.g_modify_time | dateFormat}} </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (formBlock==true) {
      <div [ngClass]="config.type == 'viewAll' ? 'box-shadow _wf-patienthistory _right-container' : '_right-container _wf-patienthistory box-shadow'"
        id="scrollTestLab " scroll-directive>
        <button class="crossbutttoninhistory navbar-toggler float-right"><i class="fa fa-times-circle kx-menu-toggle-icon" (click)="closeButton()"></i></button>
        @if (currentPrescription != undefined && currentPrescription != '') {
          <div style="height: 100%;">
            <ng2-pdfjs-viewer pdfSrc="{{currentPrescription}}"></ng2-pdfjs-viewer>
          </div>
        }
        <!-- for image -->
        @if (documentId) {
          <div>
            <app-document-viewer [multiDocumentId]="documentIds" [config]="configForDocument"></app-document-viewer>
          </div>
        }
        @if (remarks != undefined && remarks != '') {
          <div class="row mt-2">
            <span class="text-primary font-weight-bold col-sm-4 ">Remarks </span>
            <span class="col-sm-4">{{remarks}} </span>
          </div>
        }
      </div>
    }
  </div>
</div>
}